import { render, staticRenderFns } from "./tslx.vue?vue&type=template&id=21ad22a0&scoped=true&"
import script from "./tslx.vue?vue&type=script&lang=js&"
export * from "./tslx.vue?vue&type=script&lang=js&"
import style0 from "./tslx.vue?vue&type=style&index=0&id=21ad22a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad22a0",
  null
  
)

export default component.exports